import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import addEditCopyClaims from '../components/addEditCopyClaims.vue';

var AddClaimsPage = function (_super) {
  __extends(AddClaimsPage, _super);

  function AddClaimsPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddClaimsPage = __decorate([Component({
    components: {
      addEditCopyClaims: addEditCopyClaims
    }
  })], AddClaimsPage);
  return AddClaimsPage;
}(Vue);

export default AddClaimsPage;